import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";

const FAQS = [
    {
        q: "Is this a physical product?",
        a: "No. It is a digital PDF that you can read on your phone, tablet or computer.",
    },
    {
        q: "How much does it cost?",
        a: "The introductory price is ₹49 only.",
    },
    {
        q: "How will I receive it?",
        a: "After successful payment, you will be directed to a thank-you/download page or receive instructions for accessing the PDF.",
    },
    {
        q: "How long does it take?",
        a: "The guide is designed as a simple 5-day experience, with a few minutes of reflection and action each day.",
    },
    {
        q: "Is this therapy or counselling?",
        a: "No. It is a self-guided relationship reflection and practical reset guide. It is not a substitute for professional therapy or counselling.",
    },
    {
        q: "Will this guarantee that my husband changes?",
        a: "No. The guide focuses on awareness, reflection and practical steps that may support better communication and connection.",
    },
];

export const Faq = () => {
    const [open, setOpen] = useState(0);

    return (
        <section className="bg-cream py-16 sm:py-24" data-testid="faq-section">
            <div className="mx-auto max-w-3xl px-5 sm:px-8">
                <Reveal className="text-center">
                    <h2 className="font-serif text-2xl font-medium text-plum sm:text-3xl lg:text-4xl">
                        Frequently Asked <em className="italic text-burgundy">Questions</em>
                    </h2>
                </Reveal>

                <div className="mt-10 space-y-4" data-testid="faq-accordion">
                    {FAQS.map((f, i) => (
                        <Reveal key={f.q} delay={i * 0.04} y={16}>
                            <div
                                className="overflow-hidden rounded-2xl border border-blushline bg-white shadow-sm"
                                data-testid={`faq-item-${i + 1}`}
                            >
                                <button
                                    onClick={() => setOpen(open === i ? -1 : i)}
                                    aria-expanded={open === i}
                                    className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                                    data-testid={`faq-trigger-${i + 1}`}
                                >
                                    <span className="font-serif text-lg text-plum sm:text-xl">{f.q}</span>
                                    <motion.span animate={{ rotate: open === i ? 45 : 0 }} transition={{ duration: 0.25 }}>
                                        <Plus className="h-5 w-5 shrink-0 text-gold" />
                                    </motion.span>
                                </button>
                                <AnimatePresence initial={false}>
                                    {open === i && (
                                        <motion.div
                                            initial={{ height: 0, opacity: 0 }}
                                            animate={{ height: "auto", opacity: 1 }}
                                            exit={{ height: 0, opacity: 0 }}
                                            transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
                                            className="overflow-hidden"
                                        >
                                            <p className="px-6 pb-6 text-[0.95rem] leading-relaxed text-mutedtext sm:text-base">
                                                {f.a}
                                            </p>
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Faq;
